import React from 'react';
import { Card, Box, useWindowSize } from 'vindi-ds-components';
import Form from './Form';
import Header from './Header';

function CadastralUpdateForm() {
  const { isMobile } = useWindowSize();

  return (
    <Card width={isMobile ? '80%' : '40%'} style={{ overflow: 'auto' }}>
      <Box padding='4.5rem' height={{ xs: '90vh', lg: 'auto' }}>
        <Header />
        <Form />
      </Box>
    </Card>
  );
}

export default CadastralUpdateForm;
